import { GetAppMetricsTotalSummaryIndividualRequestDto } from '../../../../../src/interface/dtos/team-metrics/summary/get-app-metrics-total-summary-individual.request.dto';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetAppMetricsTotalSummaryIndividualQuery } from '../../../../../src/interface/queries/team-metrics/summary/get-app-metrics-total-summary-individual.query';
import { GetAppMetricsTotalSummaryIndividualResponseArray } from '../../../../../src/interface/dtos/team-metrics/summary/get-app-metrics-total-summary-individual.response.dto';
import { AppMetricsTotalSummaryIndividualMapper } from '../../../../../src/infrastructure/mappers/team-metrics/summary/app-metrics-total-summary-individual.mapper';

export class GetAppMetricsTotalSummaryIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsTotalSummaryIndividualQuery,
    protected readonly mapper: AppMetricsTotalSummaryIndividualMapper
  ) {}

  async get(
    props: GetAppMetricsTotalSummaryIndividualRequestDto
  ): Promise<GetAppMetricsTotalSummaryIndividualResponseArray> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `AppMetricsTotalSummaryIndividualController.get encountered an error: ${error}`
      );
    }
  }
}
